define('responsive-game-feed/app/scripts/views/PitchesDisplay',['require','exports','module','../utils/Tracking','hogan/web/builds/3.0.2/hogan-3.0.2.min.amd','../utils/Utils','../utils/PitchUtils','../utils/HotColdUtils'],function(require, exports, module) {

    'use strict';
    
    var tracking = require("../utils/Tracking");
    var hogan = require("hogan/web/builds/3.0.2/hogan-3.0.2.min.amd");
    var Utils = require("../utils/Utils");
    var PitchUtils = require("../utils/PitchUtils");
    var HotColdUtils = require("../utils/HotColdUtils");
    var elem = document.createElement('canvas');
   

    function PitchesDisplay(div, pitches, hotColdData) {
	
	    // INHERITED MEMBERS //
	    this.label = "Pitches Display Component";
	    this.targetDiv = div;
	    this.element = $(div);
	    this.hotColdData = hotColdData;
	    //this.componentHTML = "#pitchesDisplay";
	    /* new */
	    this.pitches = pitches
	    //this.localData = data;
	
	    // PRIVATE MEMBERS //
	    var self = this,
	        //atbatID = 0,
	        //pitches = [], // the pitch objects
	        pitchCanvas = null, // the canvas element for 3D stuff
	        pitchContext = null, // 2D context for 3D canvas, whatever that means
	        pitchCount = 0,
	        pitchLabel = 0,
	        pitchID = 0,
	        strikezoneContainer = null,
	        // real world constants
	        pixelsPerFoot3D = 50,
	        kEyeToScreen = 10, // wide angle lens closer to the screen
	        homePlateWidth = 1.1417,
	        homePlateFrontY = 1.1417,
	        pitchViewBottomMargin = 66,
	        cameraAdjustedPitchViewBottomMargin = 0,
	        // 2D Constraints
	        offsetX = 86,
	        offsetY = 110,
	        appWidth = null,
	        appHeight = null,
	        // 3D camera simulation
	        is3Denabled = false,
	        kXoffset = 0, // pitch X adjsutment
	        kYoffset = 0, // pitch Y adjsutment
	        // selection
	        ballPathOpacity = .80,
	        // Animation
	        pauseBetweenPitches = 1500, // in milliseconds
	        animationPointsTotal = 42,
	
	        maxlinewidth = 14,
	        minlinewidth = 8.5,
	        szBaseHeight = 8.5, // % originally entered for margin top in the css. // TODO find a way to get this dynamically 
	        szPosAdjust = 30, // % sz is now at....
	        aspectRatio = (130 / 130),
	        midInning = false;
	
	
	    /* ***************** PUBLIC FUNCTIONS ***************** */
	    this.init = function() {
	        defineElements();
	        addPitchListeners();
	        this.update();
	    };
	
	
	    this.update = function() {
	        //var inProg = self.playsData().gamestate == "In Progress";
	        var inProg = true;
	        if (!inProg) {
	            hideStrikezone();
	            clearPitches();
	            return;
	        }
	
	        if (midInning) return;
	        getPitches();
	        
	    };
	
	    /* ***************** PRIVATE FUNCTIONS ***************** */
	    /**
	     * Function defineElements
	     * @descrip stores references to many of the important divs / etc. sets some variables for later based on those divs
	     */
	
	    function defineElements() {
	        if (elem.getContext && elem.getContext('2d')) {
	            is3Denabled = true;
	            // important divs
	            pitchCanvas = self.element.find('#pitchTrails')[0];//document.getElementById('pitchTrails');
	            pitchContext = pitchCanvas.getContext('2d');
	            pitchContext.globalCompositeOperation = "source-over";
	            // fixed width
	            appWidth = pitchCanvas.width = 130;//parseFloat(self.element.width());
	            appHeight = pitchCanvas.height = 130;//parseFloat(self.element.height());
	        } else {
	            is3Denabled = false;
	            appWidth = parseFloat(self.element.width());
	            appHeight = parseFloat(self.element.height());
	        }
	    }
	
	    /**
	     * Function getPitches
	     * @descrip main action from data updates, checks data and initaites actions towards display
	     */
	
	    function getPitches() {
	        // these are yr pitches
	        //var plays = self.playsData();
	
	        self.pitches = cleanOutPickoffs(self.pitches);//(plays.atbat.pitches);
	        // in case the pitch obejct is done jacked up
	        if (typeof self.pitches === "undefined") self.pitches = [];
	
	        // if we have a new atbat
	        //if (atbatID != plays.atbat.num) clearPitches();
			/* new */
			clearPitches();
			
	        if (self.pitches.length === 0) {
	            // if there are no pitches, show no pitches
	            return;
	        } else if (self.pitches.length > pitchCount) {
	            // otherwise see if one of these pitches is for to be displaying
	            //parsePitch(plays.atbat.num);
	            parsePitch();
	        }
	
	        //atbatID = plays.atbat.num; // store the at bat id
	        //Utils.log("at bat id = " + atbatID);
	    }
	
	    /**
	     * Function parsePitch
	     * @param id : Number, the at bat id to be checked against as data happens
	     * @descrip takes the latest pitch from the array and sets in motion the functions to write it to the screen
	     */
	
	    //function parsePitch(id) {
	    function parsePitch() {
	        // mainly for tfs purposes, check to see if pitch exists...
	        //if (pitches[pitchCount] == undefined || id != self.playsData().atbat.num) return;
	        //Utils.log("pitch count is now " + pitchCount + ", and pitches.length = " + pitches.length);
	
	        // get a pitch
	        var pitch = self.pitches[pitchCount];
	
	        //see if pitch drawn already
	        if (pitch.id != pitchID) {
	            pitchLabel++;
	            $.extend(pitch, {
	                pitchLabel: pitchLabel,
	                //atbat: id
	            })
	
	            updateStrikezone(pitch.sz_top, pitch.sz_bot);
	
	            pitchID = parseInt(pitch.id);
	            //Utils.log("parsing pitch " + pitches.id);
	            // branch render based on flavor of data
	            if (is3Denabled && PitchUtils.is3Dpitch(pitch)) draw3Dpitch(pitch);
	            else add2DPitchMarker(pitch);
	
	            // increment the pitch label # separate from the pitch count #
	        }
	
	        // increment the pitch Count
	        pitchCount++;
	
	        // if there's still some pitches left execute the function again.
	        if (pitchCount < self.pitches.length) {
	            //Utils.log("Set the time out parse next pitch");
	            setTimeout(function() {
	                parsePitch(id);
	            }, pauseBetweenPitches);
	        }
	    }
	
	    /**
	     * Function updateStrikezone
	     * changes size and colors of the strike zone per pitch
	     */
	
	    function updateStrikezone(szTop, szBtm) {
	        updateHotColdZones();
	        var szH = 20; // height for no sz size data in %
	        var hasSZ = ((szTop != 0 && szBtm != 0) || (!isNaN(szTop) && !isNaN(szBtm)));
	
	        if (hasSZ) {
	            // if there is size szData resolve the top / bottom
	            // assuming that they are both some sort of y, the bottom Y - the top Y should be a height
	            var szAlt = Math.abs(szBtm - szTop);
	
	            // figure out the width of the strike zone to scale versus a real world 'assumption'
	            var multiplier = ((parseFloat(self.element.find("#defaultStrikeBox").width()) / 10) / homePlateWidth);
	            szH = (szAlt * multiplier) / aspectRatio; // create a size and adjust it for the aspect ratio
	        } else {
	            hideStrikezone();
	        }
	
	        // apply it to the strike zone and reset the position (sorta arbitray, admittedly)
	        self.element.find("#strikezoneContainer").height("100%");
	        positionStrikezone();
	    }
	
	    function updateHotColdZones() {
	        var hotCold = self.hotColdData; // get the new hot cold data
	
	        if (typeof hotCold == "undefined" || hotCold.sit.length < 13) {
	            clearStrikezone(); // clear the stike zone if there's not hC data
	            //Utils.log("There was no zoned data, sorry");
	        } else {
	            // iterate through the zones and apply the appropriate class
	            var tally = 0;
	            for (var i = 0; i < 13; i++) {
	                updateSingleField("#pitches_hotCold_zone" + i, "", getHotColdColor(hotCold.sit.zone[i]));
	                if (isNaN(hotCold.sit.zone[i].sweetness)) tally++;
	            }
	            if (tally == 13) clearStrikezone();
	        }
	    }
	
	    /**
	     * Function draw3Dpitch
	     * @param : Object PitchModel.js
	     * @descrip preps and begins process of drawing pitch trail in canvas
	     */
	
	    function draw3Dpitch(pitch) {
	        // get array of points on the the 3D arc
	        var perspectiveBallPathPoints = getPitchPathPoints(pitch, animationPointsTotal, 0);
	        // create an independent counter
	        var counter = 1;
	
	        // pitch to show to stage
	        drawPitchPath(pitch, perspectiveBallPathPoints, counter, 1);
	    }
	
	    function drawPitchPath(pitch, points, ctr, linew) {
	        //if (pitch.atbat != self.playsData().atbat.num) return;
	        if (ctr < points.length) {
	            var pt1 = points[ctr - 1];
	            var pt2 = points[ctr];
	
	            linew = linew + (.02 * ctr);
	            var l = Math.min(linew, maxlinewidth);
	
	            pitchContext.strokeStyle = PitchUtils.getTypeRBGA(pitch.pitch_type, ballPathOpacity);
	            pitchContext.beginPath();
	            pitchContext.lineWidth = l;
	            pitchContext.miterLimit = Math.round(l / 2);
	            pitchContext.moveTo(pt1[0], pt1[1]);
	            pitchContext.lineTo(pt2[0], pt2[1]);
	
	            pitchContext.lineCap = (ctr < points.length - 1) ? "round" : "butt";
	            pitchContext.lineJoin = "miter";
	            pitchContext.stroke();
	            pitchContext.closePath();
	
	            ctr++;
	            setTimeout(function() {
	                drawPitchPath(pitch, points, ctr, linew);
	            }, 5);
	        } else if (ctr == points.length) {
	            //drawBall(pitch, points[ctr-1]);
	            add3DPitchMarker(pitch, points[ctr - 1][0], points[ctr - 1][1]);
	        }
	    }
	
	
	    /**
	     * Function add2DPitchMarker
	     * @param pitchData : Object Pitch Model VO from data
	     * @descrip styles and places the appropriate pitch marker on the screen in absence of 3D data
	     */
	
	    function add2DPitchMarker(pitchData) {
	        // get the appropriate pitch div
	        var pitchDiv = getPitchDiv(pitchData.idx - 1, pitchData.type, pitchData.idx.toString()),
	
	            // calculate where to position it from there
	            flop = -1, // for pitcher vs batter view
	            scaleFactor2DX = scaleFactor2DY = (homePlateWidth) / (parseFloat(self.element.find("#defaultStrikeBox").width()) / 100),
	
	            // ball position ass-scaled for the screen
	            ballX = (parseFloat(pitchData.x) - (offsetX)) * flop,
	            ballY = parseFloat(pitchData.y) - (offsetY),
	
	            // finding the middle of the ball
	            ballW = 11,
	            ballH = 11,
	
	            // finding the middle of the ball
	            xScaleFineTune = 1.15,
	            yScaleFineTune = 1.05,
	
	
	
	            // final ball position
	            xAdjustedPos = (xScaleFineTune * (ballX * scaleFactor2DX)) - ballW,
	            yAdjustedPos = (yScaleFineTune * (ballY * scaleFactor2DY)) - ballH;
	
	        // apply the calculated position to the ball
	        pitchDiv.css("margin-left", xAdjustedPos + "px");
	        pitchDiv.css("margin-top", yAdjustedPos + "px");
	    }
	
	    /**
	     * Function add3DPitchMarker
	     * @param pitchData : Object PitchModel.js
	     * @param x : Number
	     * @param y : Number
	     * @descrip styles the appropriate pitch marker to the pitch and places it at the end of the 3D pitch trail
	     */
	
	    function add3DPitchMarker(pitchData, x, y) {
	    	//dont render if on edge
	    	if( x >= appWidth || y >= appHeight ) {
		    	return false;
	    	}
	        // get the appropriate pitch div
	        var pitchDiv = getPitchDiv(pitchData.idx - 1, pitchData.type, pitchData.idx.toString());
	
	
	        // finding the middle of the ball
	        var ballW = pitchDiv.width() / 2;
	        var ballH = pitchDiv.height() / 2;
	
	        // center of the screen values
	        var centerX = appWidth / 2;
	        var centerY = appHeight / 2;
	
	        // the y adjustment based on how far away from center of the strike zone is from the center of the screen
	
	        var marginTop = (appHeight * (szBaseHeight / 100)) - centerY;
	
	
	        var adjust = (parseFloat(self.element.find("#strikezoneContainer").height()) / 2) + marginTop;
	        var xPos = x - centerX - ballW;
	        var yPos = y - centerY  - ballH;
	
	        // apply the calculated position to the ball
	        pitchDiv.css("margin-left", xPos + "px");
	        pitchDiv.css("margin-top", yPos + "px");
	
	        //Utils.log("pitch pos " + xPos + " / " + yPos);
	
	        //attachPitchDescrip(pitchData, pitchData.idx, xPos, (yPos - adjust), true);
	    }
	
	    /**
	     * Function attachPitchDescrip
	     * @param pitch : Object, PitchModel.js
	     * @param x : Number
	     * @param y : Number
	     * @param autoRemove: Boolean, true = setTimeout, false = manual removal (rollout mouse function probably)
	     * @param longMsg : Boolean, true = use long pitch msg; false = use short pitch msg
	     * @descrip summons tooltip; populates it with pitch data and positions it near the appropriate pitch marker
	     */
	
	    function attachPitchDescrip(pitch, idx, x, y, autoRemove, longMsg) {
	        var rollover = self.element.find("#pitchRollover");
	        var msg = (longMsg) ? getPitchMsgLong(idx, pitch) : getPitchMsgShort(idx, pitch);
	
	        $(rollover).html(msg);
	        $(rollover).addClass("rollover");
	        $(rollover).css("margin-left", (x + 28) + "px");
	        $(rollover).css("margin-top", y + "px");
	
	        if (autoRemove) setTimeout(function() {
	            clearPitchRollover(pitchCount)
	        }, 1000);
	    }
	
	    /* ***************** PRIVATE UTILITY FUNCTIONS ***************** */
	
	    function cleanOutPickoffs(rawPitches) {
	        if (typeof rawPitches == "undefined") rawPitches = [];
	        var lngth = rawPitches.length;
	        var cleanPitches = [];
	        for (var i = 0; i < lngth; i++) {
	            if (!PitchUtils.isPickoff(rawPitches[i])) {
	                cleanPitches.push(rawPitches[i]);
	            }
	        }
	
	        return cleanPitches;
	    }
	
	    /**
	     * Function getPitchPathPoints
	     * @pitch : Object PitchModel.js
	     * @numberOfPoints : Number how many divisions the path will be broken up to for animation
	     * @width : Number too honest, i'm not too sure right now
	     */
	
	    function getPitchPathPoints(pitch, numberOfPoints, width) {
	        // get how long the pitch was and determine the length of any given segment
	        var totalPitchTime = PitchUtils.timeAtYPos(pitch, homePlateFrontY);
	        var timeInterval = totalPitchTime / numberOfPoints;
	
	        var points = new Array();
	        for (var currTime = 0; currTime <= numberOfPoints; currTime++) {
	
	            var currentTime = currTime * timeInterval;
	            var pathOffset = (width > 0) ? pathOffset = width / 2 : 0;
	
	            // get x,y,z in pitchFX coordinates at time
	            var currentX = PitchUtils.xPosAtTime(pitch, currentTime) + pathOffset;
	            var currentY = PitchUtils.yPosAtTime(pitch, currentTime);
	            var currentZ = PitchUtils.zPosAtTime(pitch, currentTime);
	
	            // if pitch hits before plate, end path
	            if (currentZ < 0.1) break;
	
	            // Convert to screen space
	            // NOTE: Swap y and z and negate y to match CoreAnimation coordinate system
	            var pointOnScreen = pointOnScreenForReal(currentX, currentZ, -currentY);
	            
	            //Utils.log( pointOnScreen );
	
	            // Pitch has been clipped, end the path here
	            if (pointOnScreen[0] == 0 ||
	                pointOnScreen[0] == pitchContext.width ||
	                pointOnScreen[1] == pitchContext.height - pitchViewBottomMargin + kYoffset ||
	                pointOnScreen[1] == 0) {
	                break;
	            }
	
	            points.push(pointOnScreen);
	        }
	
	        return points;
	    }
	
	    /**
	     * Function pointOnScreenForReal
	     * @param x : Number
	     * @param y : Number
	     * @param z : Number
	     * @return : Array containing [x,y] coordinates
	     */
	
	    function pointOnScreenForReal(x, y, z) {
	        // Adjust y to be in the middle of the screen (camera is centered vertically)
	        var szDiff = (appHeight * (szBaseHeight / 100)) - parseFloat(self.element.find("#strikezoneContainer").height());
	        pitchViewBottomMargin = cameraAdjustedPitchViewBottomMargin + (szDiff / kEyeToScreen);
	        var newY = (((appHeight - pitchViewBottomMargin) / pixelsPerFoot3D) / 2) - y;
	
	        // Give the x,y perspective courtesy of z
	        var zScope = Math.abs(kEyeToScreen - z);
	        var perspectiveX = (x * (kEyeToScreen / zScope));
	        var perspectiveY = (newY * (kEyeToScreen / zScope));
	
	        // create the screen position
	        var zScale = 1 - Math.abs(z / 100);
	        var screenX = (perspectiveX * pixelsPerFoot3D) + (appWidth / 2);
	        var screenY = (perspectiveY * pixelsPerFoot3D) + ((appHeight / 2) - (pitchViewBottomMargin * zScale));
				screenY = Math.abs( screenY );
	        // Make sure its in the width bounds 
	        if (screenX < 0.0) {
	            screenX = 0.0;
	        } else {
	            screenX = Math.min(appWidth, screenX);
	        }
	
	        // Make sure its in the height bounds 
	        if (screenY < 0.0) {
	            screenY = 0.0;
	        } else {
	            screenY = Math.min(appHeight - pitchViewBottomMargin, screenY);
	        }
	
	        var pt = [];
	        pt[0] = screenX + kXoffset;
	        pt[1] = screenY + kYoffset;
	        return pt;
	    }
	
	    /**
	     * Function getPitchDiv
	     * @param idx : Number, index of pitch count
	     * @param type : String, indicating ball strike hit etc
	     * @param label : String, what num should be written in the pitch
	     * @return HTMLObject : reference to the html div on the screen
	     */
	
	    function getPitchDiv(idx, type, label) {
	        // get the id of the div we want to effect;
	        var pitchName = "#pitch"+idx;
	        var pitchDiv = self.element.find(pitchName);
	
	        // apply the css class by ball / strike / in-play
	        pitchDiv.addClass(getCSSbyType(type));
	        // write the number of the pitch in the div
	        pitchDiv.html(label);
	
	        // position ball in the center of the strikezone div
	        pitchDiv.css("left", "50%");
	        pitchDiv.css("top", "50%");
	
	        return pitchDiv;
	    }
	
	    /**
	     * Function positionStrikeZone
	     * @descript attempts to recenter the strike zone after the size is changed
	     */
	
	    function positionStrikezone() {
	        var szH = parseFloat(self.element.find("#strikezoneContainer").height()); // get the height of the sz
	        var viewH = appHeight; // get the hieght of the app window
	
	        // get the difference of the new sz height's % of app height from the base sz height
	        var percentDiff = ((szH / viewH) - .2) * 100;
	        szPosAdjust = szBaseHeight - (percentDiff / 2); // subtract half that diff from the base sz position
	        
	        //self.element.find("#strikezoneContainer").css("margin-top", szPosAdjust + "%");
	
	        // make sure the strike area is centered within the strike zone that includes the margin zones
	        var margin = (szH - parseFloat(self.element.find("#defaultStrikeBox").height())) / 2;
	        
	        //self.element.find("#defaultStrikeBox").css("margin-top", margin + "px");
	    }
	
	    /**
	     * Function clearStrikezone
	     * @descrip Remove all hot cold zones from strike zone
	     */
	
	    function clearStrikezone() {
	        for (var i = 0; i < 13; i++) {
	            var zoneID = "#pitches_hotCold_zone" + i;
	            $(zoneID).removeClass($(zoneID).attr("class"));
	        }
	    }
	
	    function hideStrikezone() {
	        self.element.find("#strikezone").css("visibility", "hidden");
	    }
	
	    function showStrikezone() {
	        self.element.find("#strikezone").css("visibility", "visible");
	    }
		
		function updateSingleField (elementID, content, css) {
			self.element.find(elementID).html(content);
			
			if (css != null) {
				self.element.find(elementID).removeClass(self.element.find(elementID).attr("class"));
				self.element.find(elementID).addClass(css);
			}
		}
		
	    /**
	     * Function getHotColdZone
	     * @param zone : Object
	     * @return string representing class name of hC color
	     */
	
	    function getHotColdColor(zone) {
	        return HotColdUtils.getHotZoneColorClass(parseFloat(zone.sweetness), "b");
	    }
	
	    function getCSSbyType(type) {
	        //Utils.log("this is the type of pitch: " + type);
	        switch (type) {
	            case "S":
	                return "pitchMarkerBase strikeMarker";
	                break;
	            case "B":
	                return "pitchMarkerBase ballMarker";
	                break;
	            case "X":
	                return "pitchMarkerBase hitMarker";
	                break;
	        }
	    }
	
	
	    function pause(milliseconds) {
	        var dt = new Date();
	        while ((new Date()) - dt <= milliseconds) { /* Do nothing */ }
	    }
	
	    /**
	     * Function getPitchMsgShort
	     * @param idx : Number, current pitch count
	     * @param pitchData : Object, PitchModel.js
	     * @return : String, concatenated message describing pitch
	     */
	
	    function getPitchMsgShort(idx, pitchData) {
	        // create strings of the appropriate data
	        var num = "&#35;" + idx + " ";
	        var desc = pitchData.des.toString() + " ";
	        var type = (typeof pitchData.pitch_type != "undefined") ? " / " + PitchUtils.getFullName(pitchData.pitch_type) : "";
	        return num + desc + type;
	    }
	
	    /**
	     * Function getPitchMsgLong
	     * @param idx : Number, current pitch count
	     * @param pitchData : Object, PitchModel.js
	     * @return : String, concatenated message describing pitch
	     */
	
	    function getPitchMsgLong(idx, pitchData) {
	        // get the absolute basics down
	        var num = "&#35;" + idx + " ";
	        var desc = pitchData.des.toString() + " ";
	        var type = (typeof pitchData.pitch_type != "undefined") ? "<br>" + self.getLocalizedString("components.pitchTooltip.PitchType") + PitchUtils.getFullName(pitchData.pitch_type) : "";
	        var details = "";
	
	        // attempt to get the fancy data
	        try {
	            if (pitchData.x0) {
	                var nasty = (typeof pitchData.nasty != "undefined" && pitchData.nasty != "") ? "<br>" + self.getLocalizedString("components.pitchTooltip.NastyFactor") + pitchData.nasty : "<br>" + self.getLocalizedString("components.pitchTooltip.NastyFactor") + " --";
	                var release = "<br>" + self.getLocalizedString("components.pitchTooltip.ReleaseSpeed") + formatDecimal(pitchData.start_speed) + self.getLocalizedString("components.pitchTooltip.MPH");
	                var speed = "<br>" + self.getLocalizedString("components.pitchTooltip.ResultSpeed") + formatDecimal(pitchData.end_speed) + self.getLocalizedString("components.pitchTooltip.MPH");
	
	                var pFX = "<br>" + self.getLocalizedString("components.pitchTooltip.PitchFX") + ((pitchData.getPfxString(true).length > 0) ? pitchData.getPfxString(true) : "--");
	                var brk = "<br>" + self.getLocalizedString("components.pitchTooltip.Break") + ((formatDecimal(pitchData.break_length) === "--") ? "--" : formatDecimal(pitchData.break_length) + "''");
	                var brkAngle = (typeof pitchData.break_angle !== "undefined") ? " / " + pitchData.break_angle + self.getLocalizedString("components.pitchTooltip.BreakAngleSuffix") : "";
	
	                // concat the fancy data
	                details = nasty + release + speed + pFX + brk + brkAngle;
	            }
	        } catch (err) {
	            Utils.log("Error at getPitchMsgLong: " + err);
	        }
	
	        // return what you can
	        return num + desc + type + details;
	    }
	
	    function formatDecimal(num) {
	        if (isNaN(num)) return "--";
	        else return Math.floor(num) + "." + Math.abs(Math.round((Math.floor(num) - num) * 10));
	    }
	
	    /**
	     * Function clearPitches
	     * @descrip removes all contents and styles from the pitch divs essentially removing them from the stage
	     *
	     */
	
	    function clearPitches() {
	        for (var i = 0; i < 21; i++) {
	            var pitchDiv = self.element.find("#pitch" + i);
	            pitchDiv.html("");
	            pitchDiv.removeClass($(pitchDiv).attr("class"));
	        }
	
	        if (is3Denabled) pitchContext.clearRect(0, 0, appWidth, appHeight);
	        pitchCount = 0;
	        pitchLabel = 0;
	        clearPitchRollover(1000);
	    }
	
	    /**
	     * Function clearPitchRollover
	     * @param idx : Number, the pitch div to clear
	     * @descrip hides the pitch tooltip, pass some exorbanantly high number to force clear
	     */
	
	    function clearPitchRollover(idx) {
	        // don't clear if this command came from a set timeout of a previous pitch and we've already moved on
	        if (idx >= pitchCount) {
	            var div = self.element.find("#pitchRollover");
	            $(div).removeClass($(div).attr("class"));
	            $(div).html("");
	        }
	    }
	
	
	    /* ***************** EVENT CHAIN FUNCTIONS ***************** */
	    /**
	     * Function addPitchListeners
	     * assigns rollover / rollout functions to all the permanent pitch elements
	     */
	
	    function addPitchListeners() {
	        // iterate through all the pitch id's
	        /*for (var i = 0; i < 21; i++) {
	            var pitchDiv = self.element.find("#pitch" + i);
	            var idx = i;
	            $(pitchDiv).mouseenter(handlePitchRollover);
	            $(pitchDiv).mouseleave(handlePitchRollout);
	        }*/
	    }
	
	    /**
	     * Function handleGameUpdateEvent
	     * @param evt : Object
	     * @param val : Object
	     * @descrip handler for model updates...
	     */
	
	    function handleGameUpdateEvent(evt, val) {
	        // don't waste cycles on stuff you can't see...
	        if (!self.visible) return;
	        getPitches();
	    }
	
	    /**
	     * Function handlePitchRollover
	     * @param evt : Object
	     * @descrip abstract handler for all the rollovers of all the pitches
	     */
	
	    function handlePitchRollover(evt) {
	        // get the appropriate div and strip some information out of it
	        var div = self.element.find("#" + evt.target.id);
	        var x = parseFloat($(div).css("margin-left"));
	        var y = parseFloat($(div).css("margin-top"));
	
	        // find the center of the strike zone in relation to the rest of the screen
	        var adjust = (parseFloat(self.element.find("#strikezoneContainer").height()) / 2);
	
	        // use the name of the rolled over div to get the appropriate pitch object
	        var pitchNum = parseFloat(evt.target.id.substr(5));
	        var pitch = pitches[pitchNum];
	
	        // tell the tooltip to appear
	        attachPitchDescrip(pitch, pitchNum + 1, x, (y + adjust), false, true);
	
	        //Tracking.track_pitches_activity();
	    }
	
	    /**
	     * Function handlePitchRollout
	     * @param evt : Object
	     * @descrip abstract handler for all the rollouts of all the pitches
	     */
	
	    function handlePitchRollout(evt) {
	        clearPitchRollover(1000);
	    }
	
	    function handleSceneEventChange(evt, evtArgs) {
	        for (var i = 0, lngth = evtArgs.eventEnums.length; i < lngth; i++) {
	            var event = evtArgs.eventEnums[i];
	            if (event == SceneStateEnums.ABSTRACT_GAME_STATE_CHANGE_TO_LIVE) {
	                showStrikezone();
	                break;
	            } else if (event == SceneStateEnums.NEW_BATTER) {
	                //updateHotColdZones();
	                clearPitches();
	            } else if (event == SceneStateEnums.ABSTRACT_GAME_STATE_CHANGE_TO_FINAL) {
	                hideStrikezone();
	                clearPitches();
	                self.removeEventListners();
	                break;
	            }
	        }
	    }
	
	    function handleMidInning(evt, evtArgs) {
	        if (evtArgs.eventType === WidgetActivationEvent.SHOW && evtArgs.componentEnum === ViewComponentEnums.MID_INNING_SCENE_VIEW) {
	            midInning = true;
	            hideStrikezone();
	            clearPitches();
	        } else if (evtArgs.eventType === WidgetActivationEvent.HIDE && evtArgs.componentEnum === ViewComponentEnums.MID_INNING_SCENE_VIEW) {
	            midInning = false;
	            showStrikezone();
	            self.update();
	        }
	    }
	
	}
	return PitchesDisplay;
	
  
});
